module.exports = __webpack_public_path__ + "img/ellipse.8de0993b.png";